'use client';

import { CSSProperties, FC, useCallback, useRef, useState } from 'react';
import dynamic from 'next/dynamic';

import { LottieRefCurrentProps } from 'lottie-react';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

export interface IAnimationButton {
  additionalStyles?: CSSProperties;
  autoPlay?: boolean;
  animationData: unknown;
  height?: number;
  loop?: boolean;
  width?: number;
  onSuccessCallback: () => void;
  onClickCallback?: () => void;
}

export const AnimationButton: FC<IAnimationButton> = (props) => {
  const {
    additionalStyles,
    animationData,
    autoPlay = false,
    height,
    loop = false,
    width,
    onSuccessCallback,
    onClickCallback,
  } = props;

  const [isPlaying, setPlaying] = useState<boolean>(false);
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  const handleClick = useCallback((event: any) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();

    if (!isPlaying) {
      setPlaying(() => true);

      onClickCallback?.();

      lottieRef.current?.stop();
      lottieRef.current?.play();
    }
  }, [isPlaying, onClickCallback]);

  const handleComplete = useCallback(() => {
    setPlaying(() => false);

    onSuccessCallback();
  }, [onSuccessCallback]);

  return (
    <Lottie
      autoplay={autoPlay}
      autoPlay={autoPlay}
      loop={loop}
      lottieRef={lottieRef}
      animationData={animationData}
      style={{
        cursor: 'pointer',
        height: height ? `${height}px` : 'auto',
        width: width ? `${width}px` : 'auto',
        ...(additionalStyles ?? {}),
      }}
      onClick={handleClick}
      onComplete={handleComplete}
    />
  );
};
